import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import useSetPdpEditOrderErrorMessage from './useSetPdpEditOrderErrorMessage';
const useResetPdpEditOrderErrorMessage = () => {
  const $ = _c(2);
  const setPdpEditOrderErrorMessage = useSetPdpEditOrderErrorMessage();
  let t0;
  if ($[0] !== setPdpEditOrderErrorMessage) {
    t0 = () => {
      setPdpEditOrderErrorMessage(null);
    };
    $[0] = setPdpEditOrderErrorMessage;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const resetPdpEditOrderErrorMessage = t0;
  return resetPdpEditOrderErrorMessage;
};
export default useResetPdpEditOrderErrorMessage;